
import styled from "styled-components";

export const DivBackgroud = styled.div`
background:#0f0e17;
height:100vh;
`